export const DATA_CENTER_CONSTANTS = {
  TITLE: "Global Data Centers Delivering Unmatched Performance",
  SUB_TITLE:
    "Experience high-speed, secure, and scalable networks with our global data centers \n Built for low-latency cloud performance.",
};
